/**
 * Robot onboarding lives in the robot-onboarding playbook app now; the
 * console has no Robots pages. Every `/robots`, `/robots/<id>` and
 * `/robots/<id>/drive` load (including signup verify's `/robots?setup=1`
 * with its refresh-token handoff) is sent to the same-env playbook with the
 * path, query and hash unchanged, before AuthProvider can strip the token.
 *
 * The playbook origin comes from `VITE_ROBOT_ONBOARDING_URL` (set per env at
 * build time), else from the deployed console host, else the dev playbook.
 */

const playbookOriginByConsoleHost: Record<string, string> = {
  'metaphysics-dev.formant.ai': 'https://robot-onboarding-dev.vercel.app',
  'metaphysics-stage.formant.ai': 'https://robot-onboarding-stage.vercel.app',
  'metaphysics.formant.ai': 'https://robot-onboarding-prod.vercel.app',
};

const devPlaybookOrigin = 'https://robot-onboarding-dev.vercel.app';

export function playbookOrigin(hostname: string, configured?: string): string {
  const fromEnv = configured?.trim().replace(/\/+$/, '');
  if (fromEnv) return fromEnv;
  return playbookOriginByConsoleHost[hostname] ?? devPlaybookOrigin;
}

export function playbookRedirect(href: string, origin: string): string | null {
  let url: URL;
  try {
    url = new URL(href);
  } catch {
    return null;
  }
  if (url.pathname !== '/robots' && !url.pathname.startsWith('/robots/')) return null;
  return `${origin}${url.pathname}${url.search}${url.hash}`;
}
